import * as React from "react";

export interface IAttachmentProps {
    fileName: string;
    fileUrl: string;
    fileType: string;
}

export const AttachmentIcon = (fileExtension: string) => {
    let icon = "fa fa-file";
    switch (fileExtension.toLowerCase()) {
        case "jpg":
        case "png":
        case "jpeg":
        case "tiff":
        case "gif":
        case "bmp":
        case "jpe":
            icon = "fa fa-file-image-o";
            break;
        case "xls":
        case "xlsx":
        case "odt":
            icon = "fa fa-file-excel-o";
            break;
        case "pdf":
            icon = "fa fa-file-pdf-o";
            break;
        case "docx":
        case "doc":
            icon = "fa fa-file-word-o";
            break;
        case "ppt":
        case "pptx":
            icon = "fa fa-file-powerpoint-o";
            break;
        case "xml":
            icon = "fa fa-file-code-o";
            break;
        case "mp3":
        case "mp4":
        case "mpp":
        case "mov":
        case "wma":
        case "wmv":
        case "wav":
            icon = "fa fa-file-audio-o";
            break;
        case "rar":
        case "zip":
            icon = "fa fa-file-archive-o";
            break;
        case "txt":
        case "pages":
            icon = "fa fa-file-text";
            break;
        default:
            icon = "fa fa-file";
            break;
    }

    return icon;
};

export const AttachmentRow = (props: IAttachmentProps) => {
    const fileName = props.fileName;
    const fileUrl = props.fileUrl;
    const fileType = props.fileType;
    const icon = "CAL-EVENT-cR-l-icon " + AttachmentIcon(fileType);

    return (
        <li>
            <a href={fileUrl} className="CAL-EVENT-cR-l-downloadItem" download>
                <em className={icon} />
                <span>{fileName}</span>
                <em className="fa fa-download" />
            </a>
        </li>
    );
};
